import apiRequest from './client';

// GET /api/banks/bank-report/ (portail company, Rapports > Rapport du Banque).
// Contrairement au Rapport du Terminal (liste plate), celui-ci regroupe par Group.
// filter = 'All'|'Group'|'Supervisor'|'Bank', scope = id du group/superviseur/bank
// (omis pour 'All'). orderBy = jusqu'a 2 {field: 'Code'|'Nom', dir: 'Asc'|'Desc'}, appliques
// sur les GROUPS (pas les terminaux). withDetails = inclut ou non la liste des
// terminaux de chaque group. qty = {op: '>'|'>='|'<'|'<='|'=', value} filtre les
// groups par nombre de terminaux. Renvoie une liste de
// { id, name, address, terminal_count, terminals?: [{terminal, nom}] }.
export const fetchBankReport = ({ filter = 'All', scope, orderBy = [], withDetails = true, qty } = {}) => {
  const params = new URLSearchParams({ filter, with_details: String(withDetails) });
  if (scope) params.set('scope', scope);
  orderBy.forEach(({ field, dir }, i) => {
    params.set(`order_by${i + 1}`, field);
    params.set(`order_dir${i + 1}`, dir);
  });
  if (qty?.op && qty.value !== '' && qty.value != null) {
    params.set('qty_op', qty.op);
    params.set('qty_value', qty.value);
  }
  return apiRequest(`/banks/bank-report/?${params.toString()}`);
};
